import { apiClient } from '@/lib/api-client';

export interface CatalogSearchResult {
  type: 'MATERIAL' | 'SERVICE';
  sku: string;
  description: string;
  unit: string | null;
  unitCost: number | null;
  costSource: 'CATALOG' | 'CACHE' | 'PARTNER_SERVICE';
}

export const catalogApi = {
  /**
   * Typeahead search across products + services.
   * @param q      Search string.
   * @param type   Optional restriction: 'M' for materials (products), 'S' for services.
   * @param limit  Max rows (default 20).
   */
  search: async (
    q: string,
    type?: 'M' | 'S',
    limit = 20,
  ): Promise<CatalogSearchResult[]> => {
    return apiClient.get<CatalogSearchResult[]>('/catalog/search', {
      params: {
        q,
        ...(type && { type }),
        limit,
      },
    });
  },

  /** Latest unit cost for a known SKU — used to refresh a picked row. */
  latestCost: async (
    sku: string,
    type: 'MATERIAL' | 'SERVICE',
  ): Promise<{ unitCost: number | null; source: string } | null> => {
    return apiClient.get('/catalog/latest-cost', { params: { sku, type } });
  },
};
